"use strict";
'use client';
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
// @inheritedComponent IconButton
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _refType = _interopRequireDefault(require("@mui/utils/refType"));
var _composeClasses = _interopRequireDefault(require("@mui/utils/composeClasses"));
var _colorManipulator = require("@mui/system/colorManipulator");
var _capitalize = _interopRequireDefault(require("../utils/capitalize"));
var _createSimplePaletteValueFilter = _interopRequireDefault(require("../utils/createSimplePaletteValueFilter"));
var _SwitchBase = _interopRequireDefault(require("../internal/SwitchBase"));
var _zeroStyled = require("../zero-styled");
var _memoTheme = _interopRequireDefault(require("../utils/memoTheme"));
var _DefaultPropsProvider = require("../DefaultPropsProvider");
var _switchClasses = _interopRequireWildcard(require("./switchClasses"));
var _useSlot = _interopRequireDefault(require("../utils/useSlot"));
var _jsxRuntime = require("react/jsx-runtime");
var useUtilityClasses = function(ownerState) {
    var classes = ownerState.classes, edge = ownerState.edge, size = ownerState.size, color = ownerState.color, checked = ownerState.checked, disabled = ownerState.disabled;
    var slots = {
        root: [
            'root',
            edge && "edge".concat((0, _capitalize.default)(edge)),
            "size".concat((0, _capitalize.default)(size))
        ],
        switchBase: [
            'switchBase',
            "color".concat((0, _capitalize.default)(color)),
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    var composedClasses = (0, _composeClasses.default)(slots, _switchClasses.getSwitchUtilityClass, classes);
    return _object_spread({}, classes, composedClasses);
};
var _obj;
var SwitchRoot = (0, _zeroStyled.styled)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.root,
            ownerState.edge && styles["edge".concat((0, _capitalize.default)(ownerState.edge))],
            styles["size".concat((0, _capitalize.default)(ownerState.size))]
        ];
    }
})({
    display: 'inline-flex',
    width: 34 + 12 * 2,
    height: 14 + 12 * 2,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: (_obj = {
                width: 40,
                height: 24,
                padding: 7
            }, _define_property(_obj, "& .".concat(_switchClasses.default.thumb), {
                width: 16,
                height: 16
            }), _define_property(_obj, "& .".concat(_switchClasses.default.switchBase), _define_property({
                padding: 4
            }, "&.".concat(_switchClasses.default.checked), {
                transform: 'translateX(16px)'
            })), _obj)
        }
    ]
});
var SwitchSwitchBase = (0, _zeroStyled.styled)(_SwitchBase.default, {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: function(props, styles) {
        var ownerState = props.ownerState;
        return [
            styles.switchBase,
            _define_property({}, "& .".concat(_switchClasses.default.input), styles.input),
            ownerState.color !== 'default' && styles["color".concat((0, _capitalize.default)(ownerState.color))]
        ];
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    var _obj;
    return _obj = {
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : "".concat(theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]),
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        })
    }, _define_property(_obj, "&.".concat(_switchClasses.default.checked), {
        transform: 'translateX(20px)'
    }), _define_property(_obj, "&.".concat(_switchClasses.default.disabled), {
        color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : "".concat(theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600])
    }), _define_property(_obj, "&.".concat(_switchClasses.default.checked, " + .").concat(_switchClasses.default.track), {
        opacity: 0.5
    }), _define_property(_obj, "&.".concat(_switchClasses.default.disabled, " + .").concat(_switchClasses.default.track), {
        opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : "".concat(theme.palette.mode === 'light' ? 0.12 : 0.2)
    }), _define_property(_obj, "& .".concat(_switchClasses.default.input), {
        left: '-100%',
        width: '300%'
    }), _obj;
}), (0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        '&:hover': {
            backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette.action.activeChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : (0, _colorManipulator.alpha)(theme.palette.action.active, theme.palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: _to_consumable_array(Object.entries(theme.palette).filter((0, _createSimplePaletteValueFilter.default)([
            'light'
        ])) // check all the used fields in the style below
        .map(function(param) {
            var _param = _sliced_to_array(param, 1), color = _param[0];
            var _obj;
            return {
                props: {
                    color: color
                },
                style: (_obj = {}, _define_property(_obj, "&.".concat(_switchClasses.default.checked), _define_property({
                    color: (theme.vars || theme).palette[color].main,
                    '&:hover': {
                        backgroundColor: theme.vars ? "rgba(".concat(theme.vars.palette[color].mainChannel, " / ").concat(theme.vars.palette.action.hoverOpacity, ")") : (0, _colorManipulator.alpha)(theme.palette[color].main, theme.palette.action.hoverOpacity),
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }, "&.".concat(_switchClasses.default.disabled), {
                    color: theme.vars ? theme.vars.palette.Switch["".concat(color, "DisabledColor")] : "".concat(theme.palette.mode === 'light' ? (0, _colorManipulator.lighten)(theme.palette[color].main, 0.62) : (0, _colorManipulator.darken)(theme.palette[color].main, 0.55))
                })), _define_property(_obj, "&.".concat(_switchClasses.default.checked, " + .").concat(_switchClasses.default.track), {
                    backgroundColor: (theme.vars || theme).palette[color].main
                }), _obj)
            };
        }))
    };
}));
var SwitchTrack = (0, _zeroStyled.styled)('span', {
    name: 'MuiSwitch',
    slot: 'Track',
    overridesResolver: function(props, styles) {
        return styles.track;
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        height: '100%',
        width: '100%',
        borderRadius: 14 / 2,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : "".concat(theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white),
        opacity: theme.vars ? theme.vars.opacity.switchTrack : "".concat(theme.palette.mode === 'light' ? 0.38 : 0.3)
    };
}));
var SwitchThumb = (0, _zeroStyled.styled)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb',
    overridesResolver: function(props, styles) {
        return styles.thumb;
    }
})((0, _memoTheme.default)(function(param) {
    var theme = param.theme;
    return {
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    };
}));
var Switch = /*#__PURE__*/ React.forwardRef(function Switch(inProps, ref) {
    var props = (0, _DefaultPropsProvider.useDefaultProps)({
        props: inProps,
        name: 'MuiSwitch'
    });
    var className = props.className, _props_color = props.color, color = _props_color === void 0 ? 'primary' : _props_color, _props_edge = props.edge, edge = _props_edge === void 0 ? false : _props_edge, _props_size = props.size, size = _props_size === void 0 ? 'medium' : _props_size, sx = props.sx, _props_slots = props.slots, slots = _props_slots === void 0 ? {} : _props_slots, _props_slotProps = props.slotProps, slotProps = _props_slotProps === void 0 ? {} : _props_slotProps, other = _object_without_properties(props, [
        "className",
        "color",
        "edge",
        "size",
        "sx",
        "slots",
        "slotProps"
    ]);
    var ownerState = _object_spread_props(_object_spread({}, props), {
        color: color,
        edge: edge,
        size: size
    });
    var classes = useUtilityClasses(ownerState);
    var externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    var _ref = _sliced_to_array((0, _useSlot.default)('root', {
        className: (0, _clsx.default)(classes.root, className),
        elementType: SwitchRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            sx: sx
        }
    }), 2), RootSlot = _ref[0], rootSlotProps = _ref[1];
    var _ref1 = _sliced_to_array((0, _useSlot.default)('thumb', {
        className: classes.thumb,
        elementType: SwitchThumb,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), ThumbSlot = _ref1[0], thumbSlotProps = _ref1[1];
    var icon = /*#__PURE__*/ (0, _jsxRuntime.jsx)(ThumbSlot, _object_spread({}, thumbSlotProps));
    var _ref2 = _sliced_to_array((0, _useSlot.default)('track', {
        className: classes.track,
        elementType: SwitchTrack,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    }), 2), TrackSlot = _ref2[0], trackSlotProps = _ref2[1];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(RootSlot, _object_spread_props(_object_spread({}, rootSlotProps), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(SwitchSwitchBase, _object_spread_props(_object_spread({
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState
            }, other), {
                classes: _object_spread_props(_object_spread({}, classes), {
                    root: classes.switchBase
                }),
                slots: _object_spread({}, slots.switchBase && {
                    root: slots.switchBase
                }, slots.input && {
                    input: slots.input
                }),
                slotProps: _object_spread({}, slotProps.switchBase && {
                    root: typeof slotProps.switchBase === 'function' ? slotProps.switchBase(ownerState) : slotProps.switchBase
                }, slotProps.input && {
                    input: typeof slotProps.input === 'function' ? slotProps.input(ownerState) : slotProps.input
                })
            })),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(TrackSlot, _object_spread({}, trackSlotProps))
        ]
    }));
});
process.env.NODE_ENV !== "production" ? Switch.propTypes = {
    // ┌────────────────────────────── Warning ──────────────────────────────┐
    // │ These PropTypes are generated from the TypeScript type definitions. │
    // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
    // └─────────────────────────────────────────────────────────────────────┘
    /**
   * If `true`, the component is checked.
   */ checked: _propTypes.default.bool,
    /**
   * The icon to display when the component is checked.
   */ checkedIcon: _propTypes.default.node,
    /**
   * Override or extend the styles applied to the component.
   */ classes: _propTypes.default.object,
    /**
   * @ignore
   */ className: _propTypes.default.string,
    /**
   * The color of the component.
   * It supports both default and custom theme colors, which can be added as shown in the
   * [palette customization guide](https://mui.com/material-ui/customization/palette/#custom-colors).
   * @default 'primary'
   */ color: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'default',
            'primary',
            'secondary',
            'error',
            'info',
            'success',
            'warning'
        ]),
        _propTypes.default.string
    ]),
    /**
   * The default checked state. Use when the component is not controlled.
   */ defaultChecked: _propTypes.default.bool,
    /**
   * If `true`, the component is disabled.
   */ disabled: _propTypes.default.bool,
    /**
   * If `true`, the ripple effect is disabled.
   * @default false
   */ disableRipple: _propTypes.default.bool,
    /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   * @default false
   */ edge: _propTypes.default.oneOf([
        'end',
        'start',
        false
    ]),
    /**
   * The icon to display when the component is unchecked.
   */ icon: _propTypes.default.node,
    /**
   * The id of the `input` element.
   */ id: _propTypes.default.string,
    /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * @deprecated Use `slotProps.input` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ inputProps: _propTypes.default.object,
    /**
   * Pass a ref to the `input` element.
   * @deprecated Use `slotProps.input.ref` instead. This prop will be removed in v7. See [Migrating from deprecated APIs](/material-ui/migration/migrating-from-deprecated-apis/) for more details.
   */ inputRef: _refType.default,
    /**
   * Callback fired when the state is changed.
   *
   * @param {React.ChangeEvent<HTMLInputElement>} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */ onChange: _propTypes.default.func,
    /**
   * If `true`, the `input` element is required.
   * @default false
   */ required: _propTypes.default.bool,
    /**
   * The size of the component.
   * `small` is equivalent to the dense switch styling.
   * @default 'medium'
   */ size: _propTypes.default/* @typescript-to-proptypes-ignore */ .oneOfType([
        _propTypes.default.oneOf([
            'medium',
            'small'
        ]),
        _propTypes.default.string
    ]),
    /**
   * The props used for each slot inside.
   * @default {}
   */ slotProps: _propTypes.default.shape({
        input: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        root: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        switchBase: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        thumb: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ]),
        track: _propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object
        ])
    }),
    /**
   * The components used for each slot inside.
   * @default {}
   */ slots: _propTypes.default.shape({
        input: _propTypes.default.elementType,
        root: _propTypes.default.elementType,
        switchBase: _propTypes.default.elementType,
        thumb: _propTypes.default.elementType,
        track: _propTypes.default.elementType
    }),
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: _propTypes.default.oneOfType([
        _propTypes.default.arrayOf(_propTypes.default.oneOfType([
            _propTypes.default.func,
            _propTypes.default.object,
            _propTypes.default.bool
        ])),
        _propTypes.default.func,
        _propTypes.default.object
    ]),
    /**
   * The value of the component. The DOM API casts this to a string.
   * The browser uses "on" as the default value.
   */ value: _propTypes.default.any
} : void 0;
var _default = exports.default = Switch;
